import styled, { css } from 'styled-components';

import { ActionButton } from '../ActionButton/ActionButton';
import { fadeInOut, ITransitionStates } from '../../Animations/Animations';
import {
  cssDeclaration,
  VALID_DIMENSION_DATA,
} from '../../Utils';

const DURATION = 150;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;
`;

export const Btn = styled(ActionButton)`
  position: relative;
`;

export const DropdownContent = styled.div<{ widthProp?: VALID_DIMENSION_DATA; position?: 'left' | 'right' } & ITransitionStates>`
  position: absolute;
  max-height: none;
  overflow: auto;
  width: 100%;
  height: auto;
  left: 0;
  top: 100%;
  z-index: 9999;
  transition: opacity ${ DURATION }ms ease-out;
  ${ ({ theme: { themeTwo }, widthProp, position }) => css`
    ${ widthProp && cssDeclaration(themeTwo, 'width', widthProp) };
    ${ cssDeclaration(themeTwo, 'padding', '2x') };
    ${ cssDeclaration(themeTwo, 'box-shadow', themeTwo.modal.card.shadow) };
    ${ cssDeclaration(themeTwo, 'background-color', themeTwo.modal.card.backgroundColor) };
    ${position &&
      position === 'right' &&
      css`
        left: auto;
        right: 0;
      `}
  `}

  ${ fadeInOut }
`;
